import styled from "styled-components";

const SubTitle = styled.h4`
  display: block;
  align-items: center;
  font-size: 20px;
  font-family: "MaruBuri-Bold";

  @media (min-width: 360px) and (max-width: 600px) {
    font-size: 15px;
  }
`;

export default SubTitle;
